import { render, staticRenderFns } from "./ModalChat.vue?vue&type=template&id=b9a91ca6&scoped=true&lang=pug&"
import script from "./ModalChat.vue?vue&type=script&lang=ts&"
export * from "./ModalChat.vue?vue&type=script&lang=ts&"
import style0 from "./ModalChat.vue?vue&type=style&index=0&id=b9a91ca6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a91ca6",
  null
  
)

export default component.exports